<template>
  <el-table
    v-if="!loading && tableData.length > 0"
    height="100%"
    :data="tableData"
    style="width: 100%"
  >
    <template>
      <el-table-column label="名称" prop="name" width="220"> </el-table-column>
      <el-table-column
        v-for="(item, index) in tab"
        :key="item"
        :prop="item.prop"
        :label="item.title"
      >
        <template v-if="item.children&&item.children.length>0">
          <el-table-column
            v-for="(sub, i) in item.children"
            :key="sub"
            :prop="sub.prop"
            :label="sub.title"
          >
          </el-table-column>
        </template>
      </el-table-column>
    </template>
  </el-table>
  <div v-else class="row-center tip">
    <img v-if="loading" src="../../../assets/img/loading.png" class="loading" />
    <img v-else src="../../../assets/img/not_found_data.png" alt="" />
  </div>
</template>

<script>
import { planAndReality } from "../../../api/power";
import {
  dateFormat,
  dayStart,
  dayEnd,
  addDay,
  getAppointedDate,
} from "../../../util/DateUtil";
import { floatFormat } from "../../../util/MathUtil";
import exportExcel from "../../../util/excel";

export default {
  name: "PowerRange",
  props: {
    loops: Array,
    range: String,
    date: Date,
    node: Number,
  },
  data() {
    return {
      loading: false,
      show: true,
      tableData: [],
    };
  },
  computed: {
    propsData() {
      return [this.range, this.date, this.loops];
    },
    tab() {
      if (this.node == 0) {
        return [
          {
            title: "电（kWh）",
            children: [
              {
                title: "计划",
                prop: "energy_plan",
              },
              {
                title: "实际",
                prop: "energy_reality",
              },
            ],
          },
          {
            title: "水（m³）",
            children: [
              {
                title: "计划",
                prop: "water_plan",
              },
              {
                title: "实际",
                prop: "water_reality",
              },
            ],
          },
          {
            title: "热（GJ）",
            children: [
              {
                title: "计划",
                prop: "heat_plan",
              },
              {
                title: "实际",
                prop: "heat_reality",
              },
            ],
          },
          {
            title: "冷（GJ）",
            children: [
              {
                title: "计划",
                prop: "cooling_plan",
              },
              {
                title: "实际",
                prop: "cooling_reality",
              },
            ],
          },
        ];
      } else {
        return [
          {
            title: "电（kWh）",
            prop: "energy_reality",
          },
          {
            title: "水（m³）",
            prop: "water_reality",
          },
          {
            title: "热（GJ）",
            prop: "heat_reality",
          },
          {
            title: "冷（GJ）",
            prop: "cooling_reality",
          },
        ];
      }
    },
			diagramStatus(){
				return this.$store.state.project.diagramStatus
			},
  },
  watch: {
    propsData(n, o) {
      this.GetPlan();
    },
    node() {},
    diagramStatus(n){
				if(this.$route.params.name === 'Extremum' && this.$route.params.tag === 'Range' ){
					if(n.type === 'excel' && this.tableData.length > 0){

						let data = [
							['名称'],
              [null]
						]
            let merges = [
							{s: {r: 0, c: 0}, e: {r: 1, c: 0}},
						]
						this.tab.forEach((d, i) => {
							data[0].push(d.title, null)
							data[1].push(d.children[0].title, d.children[1].title)
							merges.push({s: {r: 0, c: 1 + i * 2}, e: {r: 0, c: 2 + i * 2}})
						})

						this.tableData.forEach(d => {
							data.push([
                d.name, 
                d.energy_plan,
                d.energy_reality,
                d.water_plan,
                d.water_reality,
                d.heat_plan,
                d.heat_reality,
                d.cooling_plan,
                d.cooling_reality,
              ])
						})
						exportExcel(data, '计划与实际报表', merges)

					}else {
						this.$message.warning("无图表数据！")
					}
				}
			},
  },
  mounted() {
    this.GetPlan();
  },
  methods: {
    //计划与实际
    async GetPlan() {
      this.loading = true;
      let currList = this.loops;
      let promises = [];
      currList.forEach((element) => {
        let obj = {
          date: dateFormat("YY-mm-dd", this.date) + "T00:00:00Z",
          buildingIds: element.id,
          projectId: this.$store.state.project.currentProject.projectId,
        };
        promises.push(planAndReality(obj));
      });
      let list = [];
      Promise.all(promises).then((res) => {
        let pointsArray = res.map((r) =>
          r.data.data.list[0] ? r.data.data.list[0] : []
        );
        pointsArray.forEach((item, index) => {
            list.push({
              name: currList[index].name,
              energy_plan: item.plan&&item.plan.electric?item.plan.electric.toFixed(2):'-',
              energy_reality: item.reality.power.toFixed(2),
              heat_plan: item.plan&&item.plan.heat?item.plan.heat.toFixed(2):'-',
              heat_reality: item.reality.heat.toFixed(2),
              water_plan: item.plan&&item.plan.water?item.plan.water.toFixed(2):'-',
              water_reality: item.reality.water.toFixed(2),
              cooling_plan: item.plan&&item.plan.cooling?item.plan.cooling.toFixed(2):'-',
              cooling_reality: item.reality.cooling.toFixed(2),
            });
        });
        this.loading = false;
        this.tableData = list;
      });
    },
  },
};
</script>

<style scoped lang="less">
.tip {
  width: 100%;
  height: 100%;
  font-size: 16rem;
  color: #8c939d;
}

.loading {
  width: 28rem;
  height: 28rem;
  animation: loading 1s linear infinite;
}

@keyframes loading {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
